import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-613df54e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-bar" }
const _hoisted_2 = { class: "search-bar__selections" }
const _hoisted_3 = { class: "search-bar__selections-filters" }
const _hoisted_4 = { class: "search-bar__selections-search" }
const _hoisted_5 = { class: "search-bar__view-filters" }
const _hoisted_6 = { class: "search-bar__view-filters-selectedFilters" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

import { Category, Island } from "@/models/DayExperience";
import { ref } from "vue";
import { debounce } from "vue-composable";
import BaseDropdown from "../base/BaseDropdown.vue";
import BaseInput from "../base/BaseInput.vue";

interface Props {
  islandOptions: Island[];
  categoryOptions: Category[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
    islandOptions: null,
    categoryOptions: null
  },
  emits: ["search"],
  setup(__props: any, { emit }) {




const islandSelect = ref([]);
const categorySelect = ref([]);
const searchValue = ref();

const removeIsland = (island: string) => {
  const index = islandSelect.value.findIndex((i) => i === island);
  islandSelect.value.splice(index, 1);
  search();
};

const removeCategory = (category: string) => {
  const index = categorySelect.value.findIndex((c) => c === category);
  categorySelect.value.splice(index, 1);
  search();
};

const clearAll = () => {
  islandSelect.value = [];
  categorySelect.value = [];
  searchValue.value = ''
  search();
};

const search = debounce(() => {
  emit("search", {
    islandFilters: islandSelect.value,
    categoryFilters: categorySelect.value,
    text: searchValue.value,
  });
}, 400);

const setLabel = (length: number) => {
  if (length === 1) return "1 option selected";
  else return `${length} options selected`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseDropdown, {
          placeholder: "Islands",
          options: __props.islandOptions,
          mode: "multiple",
          canDeselect: true,
          closeOnSelect: false,
          modelValue: islandSelect.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((islandSelect).value = $event)),
          getMultipleLabel: setLabel,
          onSelect: _unref(search)
        }, null, 8, ["options", "modelValue", "onSelect"]),
        _createVNode(BaseDropdown, {
          placeholder: "Category",
          options: __props.categoryOptions,
          mode: "multiple",
          canDeselect: true,
          closeOnSelect: false,
          modelValue: categorySelect.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((categorySelect).value = $event)),
          getMultipleLabel: setLabel,
          onSelect: _unref(search)
        }, null, 8, ["options", "modelValue", "onSelect"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseInput, {
          placeholder: "Search an experience...",
          modelValue: searchValue.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchValue).value = $event)),
          onInput: _unref(search)
        }, null, 8, ["modelValue", "onInput"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(islandSelect.value, (island) => {
          return (_openBlock(), _createElementBlock("p", { key: island }, [
            _createElementVNode("i", {
              onClick: ($event: any) => (removeIsland(island)),
              class: "gg-close"
            }, null, 8, _hoisted_7),
            _createTextVNode(" " + _toDisplayString(island), 1)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categorySelect.value, (category) => {
          return (_openBlock(), _createElementBlock("p", { key: category }, [
            _createElementVNode("i", {
              onClick: ($event: any) => (removeCategory(category)),
              class: "gg-close"
            }, null, 8, _hoisted_8),
            _createTextVNode(" " + _toDisplayString(category), 1)
          ]))
        }), 128))
      ]),
      (islandSelect.value.length || categorySelect.value.length || searchValue.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "search-bar__view-filters-clear",
            onClick: clearAll
          }, " Clear all filters "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})